export default __webpack_public_path__ + "static/media/logoBg.12a9c263.png";